import React from "react";
import styled, { css } from "styled-components";

//https://svgr.now.sh/

const Svg = styled.svg`
  display: ${props => (props.inline ? "inline" : "block")};
  flex-shrink: 0;
`;

export const Chat = ({ width = 28, height = 28, color = "#fff", ...props }) => (
  <svg width={width} height={height} viewBox="0 0 40 40" {...props}>
    <title>Chat</title>
    <path
      d="M31.406 30.486l-5.056-4.733c-.12 2.75-2.427 5.016-5.217 5.016h-8.171l-4.894 4.49c-.93.85-2.468.202-2.468-1.052v-3.64c-2.224-.607-3.802-2.67-3.802-5.016v-8.575c0-2.912 2.346-5.258 5.218-5.258h4.288v-1.699c0-3.115 2.548-5.663 5.662-5.663H32.54c3.115 0 5.663 2.548 5.663 5.663v9.505c0 2.589-1.78 4.854-4.247 5.46v4.37c0 1.334-1.578 2.062-2.549 1.132zM11.304 19.524v-6.148H7.016c-1.982 0-3.56 1.618-3.56 3.6v8.616c0 2.305 1.659 3.56 3.803 3.842v4.369l5.056-4.652h8.858c2.265 0 3.56-1.78 3.56-3.923h-7.767c-3.114-.04-5.662-2.59-5.662-5.704zm21.235-13.51H16.966a4.014 4.014 0 0 0-4.004 4.005v9.505a4.014 4.014 0 0 0 4.004 4.005h9.384l5.987 5.541v-5.38c2.386-.323 4.206-1.537 4.206-4.166V10.02a3.988 3.988 0 0 0-4.004-4.004z"
      stroke={color}
      strokeWidth={1}
      fill={color}
    />
  </svg>
);

export const Gear = props => (
  <svg width={23.14} height={24.3} viewBox="0 0 23.14 24.3" {...props}>
    <title>ico-setings</title>
    <path
      d="M8.59 0a6.59 6.59 0 0 1 4.67 11.26c.39.39.79.77 1.18 1.16a5.91 5.91 0 0 1 .58-.2v-.66a.58.58 0 0 1 .58-.59h1.93a.58.58 0 0 1 .58.59v.64a4.93 4.93 0 0 1 .6.21c.19.08.38.18.55.27l.47-.47a.58.58 0 0 1 .82 0l1.36 1.37a.57.57 0 0 1 0 .81l-.47.46a5.66 5.66 0 0 1 .28.59 4.88 4.88 0 0 1 .21.6h.66a.58.58 0 0 1 .58.58v1.91a.58.58 0 0 1-.58.58h-.69a4.93 4.93 0 0 1-.21.6 4.55 4.55 0 0 1-.27.55l.47.47a.58.58 0 0 1 0 .82L20.52 23a.56.56 0 0 1-.82 0l-.47-.46c-.18.1-.38.19-.58.28-.2.08-.4.15-.6.21v.66a.58.58 0 0 1-.58.59h-1.92a.58.58 0 0 1-.58-.59v-.64a5.49 5.49 0 0 1-.6-.21c-.19-.08-.38-.18-.55-.27l-.3.3v.46a1 1 0 0 1-1 1H4.66a1 1 0 0 1-1-1v-.86H1.61a1.8 1.8 0 0 1-1.18-.76A2.42 2.42 0 0 1 0 20.32v-2a7.15 7.15 0 0 1 .54-2.82c.7-1.7 2.16-2.92 3.46-4.19A6.59 6.59 0 0 1 8.59 0zm7.92 15.19a2.44 2.44 0 0 1 1.74.72 2.47 2.47 0 0 1 0 3.5 2.47 2.47 0 0 1-3.46-3.52 2.45 2.45 0 0 1 1.75-.72zm.93 1.54a1.33 1.33 0 0 0-1.86 0 1.32 1.32 0 0 0 0 1.86 1.28 1.28 0 0 0 .93.38 1.29 1.29 0 0 0 .9-.36 1.31 1.31 0 0 0 0-1.86zM12 12.8l-.36-.36a6.54 6.54 0 0 1-6.09 0c-1.08 1.09-2.63 2.32-3.24 3.78a5.38 5.38 0 0 0-.39 2v2a.48.48 0 0 0 0 .23h2.54V18a.58.58 0 0 1 1.16 0v4.37h5.94v-.29l-.42-.42a.58.58 0 0 1 0-.82l.47-.47a4.91 4.91 0 0 1-.28-.57 5.05 5.05 0 0 1-.21-.6h-.66a.58.58 0 0 1-.58-.58V16.7a.58.58 0 0 1 .58-.58h.66a5 5 0 0 1 .21-.6c.08-.19.17-.38.27-.56l-.47-.46a.57.57 0 0 1 0-.81l.87-.89zm6.22.74a4.12 4.12 0 0 0-.82-.25.58.58 0 0 1-.5-.57v-.53h-.77v.53a.58.58 0 0 1-.47.57 4 4 0 0 0-.85.25A4.38 4.38 0 0 0 14 14a.57.57 0 0 1-.74-.07l-.38-.38-.55.55.38.38a.59.59 0 0 1 .07.74 4.07 4.07 0 0 0-.41.75 4.25 4.25 0 0 0-.25.82.58.58 0 0 1-.57.5H11V18h.54a.57.57 0 0 1 .57.47 4.37 4.37 0 0 0 .26.85 4 4 0 0 0 .42.77.59.59 0 0 1-.06.74l-.38.38.55.55.38-.38a.57.57 0 0 1 .73-.07 4.85 4.85 0 0 0 .75.41 4.72 4.72 0 0 0 .82.25.58.58 0 0 1 .5.57v.53h.77v-.47a.59.59 0 0 1 .47-.57 4 4 0 0 0 .85-.25 4.46 4.46 0 0 0 .77-.42.57.57 0 0 1 .74.07l.38.38.55-.55-.38-.38a.59.59 0 0 1-.07-.74 4.43 4.43 0 0 0 .41-.75 4.34 4.34 0 0 0 .25-.82.58.58 0 0 1 .57-.51H22v-.76h-.54a.57.57 0 0 1-.56-.47 4.65 4.65 0 0 0-.26-.85 4.47 4.47 0 0 0-.42-.78.58.58 0 0 1 .07-.74l.38-.38-.55-.55-.38.38A.57.57 0 0 1 19 14a4.67 4.67 0 0 0-.76-.41zM8.59 1.93a4.67 4.67 0 1 0 4.67 4.67 4.68 4.68 0 0 0-4.67-4.67z"
      fill="#fff"
    />
  </svg>
);

export const Verify = props => (
  <svg width={20} height={20} viewBox="0 0 20 20" {...props}>
    <title>verify</title>
    <circle cx={10} cy={10} r={10} fill="#25a9e0" />
    <path
      d="M8.16 16.07l-5.4-5.36 1.94-2 3.12 3.1 6.67-7.27 2.17 2z"
      fill="#fff"
    />
  </svg>
);

export const Calendar = props => (
  <svg width={21} height={22.77} viewBox="0 0 21 22.77" {...props}>
    <title>ico-calendar</title>
    <path
      d="M15.85 19.86a.49.49 0 0 1-1 0v-2.6H11v2.6a.48.48 0 0 1-1 0v-2.6H6.11v2.6a.48.48 0 0 1-1 0v-2.6h-1.9a.49.49 0 0 1 0-1h1.93v-3.39H3.21a.48.48 0 0 1-.48-.49.48.48 0 0 1 .48-.48h1.93V9.3a.48.48 0 0 1 1 0v2.6H10V9.3a.48.48 0 0 1 1 0v2.6h3.9V9.3a.49.49 0 0 1 1 0v2.6h1.93a.48.48 0 0 1 .48.48.49.49 0 0 1-.48.49h-1.98v3.41h1.93a.49.49 0 0 1 0 1h-1.93v2.6zM1.62 6.39h17.76V5.12a1.75 1.75 0 0 0-.52-1.24 1.77 1.77 0 0 0-1.25-.52h-.44v.93a.81.81 0 1 1-1.62 0v-.94H5.43v.93a.81.81 0 1 1-1.62 0v-.93h-.43a1.77 1.77 0 0 0-1.25.53 1.75 1.75 0 0 0-.52 1.25v1.26zM19.38 8H1.62v11.39a1.77 1.77 0 0 0 .52 1.24 1.77 1.77 0 0 0 1.25.52h14.23a1.76 1.76 0 0 0 1.25-.52 1.77 1.77 0 0 0 .52-1.24V8zm-16-6.27h.44V.81a.81.81 0 1 1 1.62 0v.93h10.12V.81a.81.81 0 1 1 1.62 0v.93h.44a3.38 3.38 0 0 1 2.39 1 3.37 3.37 0 0 1 1 2.37v14.28a3.37 3.37 0 0 1-1 2.38 3.35 3.35 0 0 1-2.39 1H3.38a3.36 3.36 0 0 1-2.39-1H1a3.35 3.35 0 0 1-1-2.38V5.12a3.37 3.37 0 0 1 1-2.39 3.38 3.38 0 0 1 2.39-1zm2.73 11.14v3.41H10v-3.41zm4.87 0v3.41h3.9v-3.41z"
      fill="#fff"
    />
  </svg>
);

export const Bell = props => (
  <svg width={20.24} height={27.9} viewBox="0 0 20.24 27.9" {...props}>
    <title>ico-bell</title>
    <path
      d="M18.84 20.7l-.05-.06A3.71 3.71 0 0 1 17.72 19c-.29-1.21-.47-2.37-.64-3.45-.42-2.73-.83-5.56-3.37-7.2a6.12 6.12 0 0 0-1.64-.74 2.76 2.76 0 1 0-4.7-2 2.73 2.73 0 0 0 .81 1.99l.08.08a5.72 5.72 0 0 0-1.43.68 7.25 7.25 0 0 0-3 5c-.12.56-.21 1.15-.31 1.77l-.06.38c-.17 1.08-.35 2.25-.64 3.45a2.87 2.87 0 0 1-1.13 1.52A3.73 3.73 0 0 0 0 23.62a1 1 0 0 0 .63.89h5.93a3.86 3.86 0 0 0 7.66 0h5.41a.94.94 0 0 0 .62-.9 4 4 0 0 0-1.41-2.91zM9 4.52a1.57 1.57 0 0 1 1.13-.47 1.6 1.6 0 0 1 1.6 1.6 1.61 1.61 0 0 1-1.6 1.6 1.6 1.6 0 0 1-1.6-1.6A1.57 1.57 0 0 1 9 4.52zm1.39 22a2.5 2.5 0 0 1-2.44-2h4.88a2.5 2.5 0 0 1-2.44 2zM14 22.7H2.21a3.69 3.69 0 0 1 .72-.7 4.47 4.47 0 0 0 1.74-2.52c.3-1.28.49-2.48.67-3.61l.06-.37c.09-.59.18-1.16.29-1.7A5.43 5.43 0 0 1 7.86 10a4.5 4.5 0 0 1 4.82 0c2 1.26 2.19 3.77 2.52 5.88.17 1.12.36 2.33.67 3.61A5.25 5.25 0 0 0 17.4 22l.05.05a5.24 5.24 0 0 1 .58.69z"
      fill="#fff"
    />
  </svg>
);

export const SpeechBubble = props => (
  <svg width={25.02} height={22.55} viewBox="0 0 25.02 22.55" {...props}>
    <title>ico-quote</title>
    <path
      d="M6.2 8.19h1.53a.57.57 0 0 1 .58.57v2.12a.58.58 0 0 1-.58.57H5.6a.58.58 0 0 1-.6-.56V8.76a3.91 3.91 0 0 1 .32-1.78 2.57 2.57 0 0 1 .55-.71 3 3 0 0 1 .76-.49.59.59 0 0 1 .79.22.58.58 0 0 1-.29.76 1.63 1.63 0 0 0-.46.3 1.23 1.23 0 0 0-.3.38 1.87 1.87 0 0 0-.16.71zM12.51 0a13.47 13.47 0 0 1 8.79 3.15 10.19 10.19 0 0 1 3.7 7.74 10.2 10.2 0 0 1-3.72 7.75 13.47 13.47 0 0 1-8.79 3.15 14 14 0 0 1-3-.32 12.67 12.67 0 0 1-2.38-.74l-3 1.62a1.63 1.63 0 0 1-.92.2 1.68 1.68 0 0 1-.88-.34 1.64 1.64 0 0 1-.57-.76 1.66 1.66 0 0 1-.06-.94l.72-3.17a10.42 10.42 0 0 1-1.69-2.82A9.57 9.57 0 0 1 0 10.89a10.2 10.2 0 0 1 3.72-7.74A13.46 13.46 0 0 1 12.51 0zm7.54 4.6a11.6 11.6 0 0 0-7.54-2.68A11.6 11.6 0 0 0 5 4.6a8.31 8.31 0 0 0-3 6.29 7.7 7.7 0 0 0 .57 2.91 8.54 8.54 0 0 0 1.63 2.57 1 1 0 0 1 .28.91l-.72 3.13 3-1.59a1 1 0 0 1 .85 0 11.12 11.12 0 0 0 2.42.8 12.3 12.3 0 0 0 2.59.27 11.57 11.57 0 0 0 7.54-2.68 8.3 8.3 0 0 0 3-6.29 8.31 8.31 0 0 0-3-6.29zM16.23 13a6.14 6.14 0 0 1-.07 1 2.61 2.61 0 0 1-.25.8 2.67 2.67 0 0 1-.55.7 2.83 2.83 0 0 1-.76.49.58.58 0 0 1-.76-.29.59.59 0 0 1 .29-.76 1.61 1.61 0 0 0 .46-.29 1.33 1.33 0 0 0 .3-.39 1.34 1.34 0 0 0 .13-.44v-.26h-1.5a.58.58 0 0 1-.58-.58v-2.09a.58.58 0 0 1 .58-.57h2.13a.58.58 0 0 1 .58.57V13zM20 13a6.15 6.15 0 0 1-.07 1 2.75 2.75 0 0 1-.25.8 2.68 2.68 0 0 1-.55.7 2.81 2.81 0 0 1-.77.49.57.57 0 0 1-.76-.29.59.59 0 0 1 .3-.7 1.65 1.65 0 0 0 .46-.29 1.39 1.39 0 0 0 .3-.39 1.36 1.36 0 0 0 .13-.44v-.26h-1.5a.58.58 0 0 1-.58-.58v-2.15a.58.58 0 0 1 .58-.57h2.13a.58.58 0 0 1 .58.57V13zM8.8 8.75a3.9 3.9 0 0 1 .32-1.78 2.52 2.52 0 0 1 .54-.71 2.65 2.65 0 0 1 .73-.46.58.58 0 1 1 .47 1.05 1.93 1.93 0 0 0-.44.27 1.48 1.48 0 0 0-.3.38 2 2 0 0 0-.16.71h1.54a.57.57 0 0 1 .58.57v2.12a.58.58 0 0 1-.58.57H9.37a.58.58 0 0 1-.58-.57V8.76z"
      fill="#fff"
    />
  </svg>
);

export const LinkedIn = props => (
  <svg width={33.11} height={30.41} viewBox="0 0 33.11 30.41" {...props}>
    <title>Linkedin</title>
    <path
      d="M7.29 30.41H.83V9.75h6.46zM3.9 7.17A3.58 3.58 0 0 1 0 3.59 3.62 3.62 0 0 1 3.94 0a3.6 3.6 0 1 1 0 7.17zm29.21 23.24h-7.32V19.72c0-2.8-1.14-4.71-3.66-4.71a3.7 3.7 0 0 0-3.49 2.53 4.76 4.76 0 0 0-.16 1.69v11.18h-7.25s.09-18.94 0-20.66h7.25V13c.43-1.42 2.74-3.44 6.44-3.44 4.59 0 8.19 3 8.19 9.37z"
      fill="#fff"
    />
  </svg>
);

export const LinkedInShare = ({ color = "#fff", ...props }) => (
  <svg width={28} height={25} viewBox="0 0 100 100" {...props}>
    <title>LinkedIn</title>
    <rect fill={color} x="7.6" y="35.1" width="17.5" height="56.1" />
    <path
      fill={color}
      d="M16,8.6c-6.5,0-10.7,4.2-10.7,9.7c0,5.4,4.1,9.7,10.5,9.7h0.1c6.6,0,10.7-4.3,10.7-9.7C26.5,12.8,22.5,8.6,16,8.6z"
    />
    <path
      fill={color}
      d="M73,34.5c-10.1,0-16.3,5.5-17.5,9.4v-8.8H35.8c0.3,4.7,0,56.1,0,56.1h19.7V60.8c0-1.7-0.1-3.4,0.4-4.6c1.4-3.4,4.3-6.9,9.5-6.9c6.8,0,10,5.2,10,12.8v29.1h19.9V60C95.3,42.6,85.5,34.5,73,34.5z"
    />
  </svg>
);

export const Twitter = props => (
  <svg width={35.47} height={28.83} viewBox="0 0 35.47 28.83" {...props}>
    <title>Twitter</title>
    <path
      d="M34.49.53a14.53 14.53 0 0 1-4.62 1.77 7.28 7.28 0 0 0-12.59 5 7.18 7.18 0 0 0 .19 1.66 20.66 20.66 0 0 1-15-7.6A7.29 7.29 0 0 0 4.72 11a7.28 7.28 0 0 1-3.3-.91v.09a7.28 7.28 0 0 0 5.84 7.14 7.08 7.08 0 0 1-1.92.26A7.2 7.2 0 0 1 4 17.49a7.28 7.28 0 0 0 6.8 5.05 14.6 14.6 0 0 1-9 3.12 14.59 14.59 0 0 1-1.8-.1 20.62 20.62 0 0 0 11.16 3.27c13.39 0 20.71-11.09 20.71-20.71v-.94a14.76 14.76 0 0 0 3.63-3.77 14.57 14.57 0 0 1-4.18 1.15A7.28 7.28 0 0 0 34.49.53z"
      fill="#fff"
    />
  </svg>
);

export const TwitterShare = ({
  color = "#fff",
  width = 28,
  height = 25,
  ...props
}) => (
  <svg width={width} height={height} viewBox="0 0 90 90" {...props}>
    <title>Twitter</title>
    <path
      fill={color}
      d="M92.3,14.7c-3.6,2.1-7.5,3.7-11.7,4.5c-3.4-3.6-8.2-5.8-13.5-5.8c-10.2,0-18.5,8.3-18.5,18.5c0,1.4,0.2,2.9,0.5,4.2C33.7,35.2,20.1,27.9,11,16.7c-1.6,2.7-2.5,5.9-2.5,9.3c0,6.4,3.3,12.1,8.2,15.4c-3-0.1-5.9-0.9-8.4-2.3v0.2c0,9,6.4,16.4,14.8,18.1C21.6,57.8,20,58,18.3,58c-1.2,0-2.3-0.1-3.5-0.3C17.2,65,24,70.4,32.1,70.5c-6.3,5-14.3,7.9-22.9,7.9c-1.5,0-3-0.1-4.4-0.3c8.2,5.2,17.9,8.3,28.3,8.3c34,0,52.5-28.1,52.5-52.5c0-0.8,0-1.6,0-2.4c3.6-2.6,6.7-5.9,9.2-9.6c-3.3,1.5-6.9,2.5-10.6,2.9C88,22.6,90.9,19,92.3,14.7z"
    />
  </svg>
);

export const Facebook = props => (
  <svg width={14.67} height={30.41} viewBox="0 0 14.67 30.41" {...props}>
    <title>Facebook</title>
    <path
      d="M0 10.06h3.14V7c0-1.35 0-3.42 1-4.71A5.59 5.59 0 0 1 9 0a19.76 19.76 0 0 1 5.63.57l-.79 4.66a10.61 10.61 0 0 0-2.53-.38C10.13 4.84 9 5.28 9 6.5v3.55h5l-.35 4.55H9v15.8H3.14V14.61H0z"
      fill="#fff"
    />
  </svg>
);

export const FacebookShare = ({ color = "#fff", ...props }) => (
  <svg width={28} height={25} viewBox="0 0 100 100">
    <title>Facebook</title>
    <path
      fill={color}
      d="M61.4,19.2c3.6,0,7.5,1.1,7.5,1.1l2.3-13.8c0,0-4.9-1.7-16.7-1.7c-7.2,0-11.4,2.7-14.4,6.8c-2.9,3.8-3,10-3,13.9v9h-9.3v13.5h9.3v46.8h17.4V48.1h13.8l1-13.5H54.6V24.2C54.6,20.5,57.8,19.2,61.4,19.2z"
    />
  </svg>
);

export const GenericShare = ({ color = "#fff", ...props }) => (
  <svg width={28} height={25} viewBox="0 0 16 20">
    <title />
    <path
      fill={color}
      d="M10.1 15.3L7.2 13c-.8.7-1.8 1.2-3 1.2s-2.3-.5-3-1.3c-.8-.8-1.2-1.8-1.2-3s.5-2.3 1.3-3c.8-.8 1.8-1.3 3-1.3s2.3.5 3 1.3l2.9-2.3c-.3-.4-.4-1-.4-1.5 0-.9.3-1.6.9-2.2.6-.6 1.3-.9 2.2-.9.9 0 1.6.3 2.2.9.6.6.9 1.3.9 2.2 0 .9-.3 1.6-.9 2.2-.6.6-1.3.9-2.2.9-.8 0-1.6-.3-2.1-.8L7.9 7.7c.4.7.7 1.4.7 2.3 0 .8-.2 1.6-.7 2.3l2.9 2.3c.6-.5 1.3-.8 2.1-.8.9 0 1.6.3 2.2.9.6.6.9 1.3.9 2.2 0 .9-.3 1.6-.9 2.2-.6.6-1.3.9-2.2.9-.9 0-1.6-.3-2.2-.9-.6-.6-.9-1.3-.9-2.2-.1-.7 0-1.2.3-1.6zm3.8.4c-.3-.3-.7-.5-1.1-.5-.4 0-.8.2-1.1.5-.3.3-.5.7-.5 1.1 0 .4.2.8.5 1.1.3.3.7.5 1.1.5.4 0 .8-.2 1.1-.5.3-.3.5-.7.5-1.1 0-.4-.2-.8-.5-1.1zM6.1 8c-.5-.5-1.2-.8-1.9-.8-.8 0-1.5.3-2 .8s-.8 1.2-.8 2c0 .7.3 1.4.8 1.9s1.2.8 2 .8c.7 0 1.4-.3 1.9-.8s.8-1.2.8-2c0-.7-.3-1.4-.8-1.9zm7.8-6c-.3-.3-.7-.5-1.1-.5-.4 0-.8.2-1.1.5-.3.3-.5.7-.5 1.1 0 .4.2.8.5 1.1.3.3.7.5 1.1.5.4 0 .8-.2 1.1-.5.3-.3.5-.7.5-1.1 0-.4-.2-.8-.5-1.1z"
    />
  </svg>
);

// const UserWrapper = Svg.extend`
//   &:hover {
//     path {
//       fill: #135d80;
//     }
//   }
// `;
export const User = props => (
  <Svg width={78.2} height={78.2} viewBox="0 0 78.2 78.2" {...props}>
    <title>user</title>
    <path
      d="M13.35 59.25L28.5 52a13.18 13.18 0 0 1-5.25-9.44l-1.33-11.82c-1.2-10.57 7.84-16.08 17.15-16.08s18.41 5.52 17.21 16.08L55 42.57A13.17 13.17 0 0 1 49.7 52l15.15 7.25a10.86 10.86 0 0 1 4.77 4.27 39.1 39.1 0 1 0-61.06 0 10.86 10.86 0 0 1 4.79-4.27z"
      fill={props.active ? "#135d80" : "#cbd2d7"}
    />
    <path
      d="M14.74 62.11l16.68-8c1.86-.86 1.86-2.52.2-3.72a10.74 10.74 0 0 1-5.25-8.11L25 30.34c-1-8.51 6.65-12.49 14-12.49s15.09 4 14.09 12.49l-1.33 11.9a10.73 10.73 0 0 1-5.12 8c-1.46 1-1.93 2.86-.07 3.72l16.81 8.11a7.58 7.58 0 0 1 3.91 4q1.19-1.24 2.26-2.58a10.86 10.86 0 0 0-4.77-4.27L49.7 52a13.17 13.17 0 0 0 5.3-9.43l1.33-11.83c1.2-10.57-7.84-16.08-17.21-16.08s-18.4 5.51-17.2 16.08l1.33 11.83A13.18 13.18 0 0 0 28.5 52l-15.15 7.25a10.86 10.86 0 0 0-4.77 4.27q1.07 1.34 2.26 2.58a7.58 7.58 0 0 1 3.9-3.99z"
      fill="#fff"
    />
    <path
      d="M63.46 62.11L46.64 54c-1.86-.86-1.4-2.72.07-3.72a10.73 10.73 0 0 0 5.12-8l1.33-11.9c1-8.51-6.71-12.49-14.09-12.49s-15 4-14 12.49l1.33 11.9a10.74 10.74 0 0 0 5.25 8.11c1.66 1.2 1.66 2.86-.2 3.72l-16.68 8a7.58 7.58 0 0 0-3.91 4 39.07 39.07 0 0 0 56.54 0 7.58 7.58 0 0 0-3.94-4z"
      fill="#95a9b6"
    />
  </Svg>
);

export const CheckCircle = props => (
  <svg width={25} height={25} viewBox="0 0 25 25" {...props}>
    <title>check</title>
    <path
      d="M12.5 0A12.5 12.5 0 1 0 25 12.5 12.52 12.52 0 0 0 12.5 0z"
      fill="#3a9535"
    />
    <path
      d="M17.54 6.07c-.41-.18-.59-.14-.82.27l-6 11.59-3.82-6c-.27-.36-.45-.41-.82-.18l-.82.5c-.41.27-.45.45-.18.82 1.32 2.14 2.68 4.27 4 6.36a1.8 1.8 0 0 0 3.32-.18c2.09-4 4.23-8 6.27-12 .18-.36.14-.59-.27-.77z"
      fill="#fff"
    />
  </svg>
);

export const Check = props => (
  <Svg width={14.4} height={15} viewBox="0 0 14.4 15" {...props}>
    <title>check2</title>
    <path
      d="M14 .58l-.9-.47c-.42-.19-.61-.14-.85.28L6 12.39 2 6.18c-.28-.38-.47-.42-.85-.19l-.85.52c-.42.28-.47.47-.19.85C1.54 9.57 3 11.78 4.37 13.94a1.86 1.86 0 0 0 3.44-.19C10 9.66 12.18 5.52 14.3 1.38c.19-.38.14-.61-.3-.8z"
      fill="#3a9535"
    />
  </Svg>
);

export const Info = props => (
  <svg width={25} height={25} viewBox="0 0 25 25" {...props}>
    <title>info</title>
    <path
      d="M25 12.5A12.5 12.5 0 1 1 12.5 0 12.52 12.52 0 0 1 25 12.5zM14.73 6a2.19 2.19 0 0 0-4.38 0 2.2 2.2 0 0 0 2.19 2.23A2.18 2.18 0 0 0 14.73 6zm-.31 4.12h-3.73v10.76h3.73z"
      fill="#135d80"
    />
  </svg>
);

export const Pin = props => (
  <Svg width={17.01} height={22.79} viewBox="0 0 17.01 22.79" {...props}>
    <title>pin</title>
    <path
      d="M15.43 13.42l-6.08 8.9a1.05 1.05 0 0 1-1.75 0l-6.15-9A8.52 8.52 0 1 1 17 8.49a8.51 8.51 0 0 1-1.57 4.93zm-13-.72l6.08 8.88 6-8.78A7.36 7.36 0 1 0 1.15 8.49a7.49 7.49 0 0 0 1.24 4.22zm6.1-8.33a4.13 4.13 0 1 0 4.14 4.12 4.12 4.12 0 0 0-4.18-4.11zm0 1.15a3 3 0 1 1-3 3 3 3 0 0 1 2.96-2.99z"
      fill="#135d80"
    />
  </Svg>
);

export const UpDown = props => (
  <Svg width={8} height={18.58} viewBox="0 0 8 18.58" {...props}>
    <title>updown</title>
    <g fill={props.color || "#135d80"}>
      <path d="M4 0L0 8h8L4 0zM4 18.58l4-8H0l4 8z" />
    </g>
  </Svg>
);

export const X = ({ width, height, color, ...props }) => (
  <Svg
    width={width ? width : 25}
    height={height ? height : 25}
    viewBox="0 0 25 25"
    {...props}
  >
    <title>close</title>
    <path
      d="M12.51 25A12.5 12.5 0 1 1 25 12.49 12.52 12.52 0 0 1 12.51 25zm0-1.35A11.15 11.15 0 1 0 1.35 12.49a11.15 11.15 0 0 0 11.16 11.16zm.93-11.16l3.81 3.81c.2.2.2.34 0 .54l-.42.42c-.2.2-.34.2-.51 0l-3.81-3.8-3.8 3.8c-.2.2-.34.2-.54 0l-.42-.42c-.2-.2-.2-.34 0-.54l3.81-3.81-3.81-3.81c-.2-.2-.2-.31 0-.51l.42-.42c.2-.2.34-.2.54 0l3.8 3.8 3.81-3.8c.17-.2.31-.2.51 0l.42.42c.2.2.2.31 0 .51z"
      fill={color || `#135d80`}
    />
  </Svg>
);

export const I = props => (
  <svg width={7.19} height={23.79} viewBox="0 0 7.19 23.79" {...props}>
    <title>Info</title>
    <path
      d="M7.19 23.37a.39.39 0 0 1-.42.42H2.51a.39.39 0 0 1-.41-.42V12.44H.42A.39.39 0 0 1 0 12V8.38A.39.39 0 0 1 .42 8h6.35a.39.39 0 0 1 .42.42zm-.1-20.44a2.67 2.67 0 0 1-2.87 3 2.69 2.69 0 0 1-2.87-3A2.65 2.65 0 0 1 4.22 0a2.63 2.63 0 0 1 2.87 2.93z"
      fill="#fff"
    />
  </svg>
);

export const Loupe = props => (
  <Svg width={20} height={20} viewBox="0 0 20 20" {...props}>
    <title>loupe</title>
    <path
      d="M4.61 7.21a.51.51 0 0 1-.61.27.5.5 0 0 1-.26-.66 5.51 5.51 0 0 1 .54-1 6 6 0 0 1 .73-.87 6 6 0 0 1 .88-.72 6.19 6.19 0 0 1 1-.53.5.5 0 1 1 .39.92 5.06 5.06 0 0 0-.83.45 4.91 4.91 0 0 0-.73.61 4.83 4.83 0 0 0-.6.73 4.66 4.66 0 0 0-.45.83zM16.14 15l3.62 3.62a.83.83 0 0 1-1.18 1.18L15 16.14a9.11 9.11 0 0 1-9.32 1.41 9.22 9.22 0 0 1-3-2 9.2 9.2 0 0 1-2-3A9.13 9.13 0 0 1 12.61.69a9.14 9.14 0 0 1 3 2 9.16 9.16 0 0 1 1.94 2.92A9.11 9.11 0 0 1 16.14 15zM12 2.23a7.46 7.46 0 0 0-9.76 9.7 7.47 7.47 0 0 0 1.62 2.42A7.44 7.44 0 0 0 6.28 16 7.48 7.48 0 0 0 12 16a7.4 7.4 0 0 0 2.41-1.6A7.56 7.56 0 0 0 16 12a7.41 7.41 0 0 0 .56-2.85A7.5 7.5 0 0 0 16 6.31a7.49 7.49 0 0 0-1.58-2.38A7.41 7.41 0 0 0 12 2.23zm2 6.9a.5.5 0 1 1 1 0 5.92 5.92 0 0 1-.45 2.26 5.82 5.82 0 0 1-1.27 1.9 5.9 5.9 0 0 1-1.91 1.28 6 6 0 0 1-2.25.43.5.5 0 0 1 0-1 5 5 0 0 0 1.88-.35 4.8 4.8 0 0 0 1.59-1.07A4.85 4.85 0 0 0 13.64 11 4.89 4.89 0 0 0 14 9.13z"
      fill="#135d80"
    />
  </Svg>
);

export const CheckBox = props => (
  <Svg
    width={16.52}
    height={16.52}
    viewBox="0 0 16.52 16.52"
    {...props}
    role="checkbox"
    aria-checked="false"
  >
    <title>checkbox</title>
    <rect
      x={0.5}
      y={0.5}
      width={15.52}
      height={15.52}
      rx={3.68}
      ry={3.68}
      fill={props.dark ? "#135d80" : "none"}
      stroke="#135d80"
      strokeMiterlimit={10}
    />
    {props.check && (
      <path
        d="M12.11 3.45c-.28-.12-.4-.09-.55.18l-4.07 7.81-2.57-4c-.18-.25-.31-.28-.55-.12l-.55.34c-.28.18-.31.31-.12.55.87 1.39 1.79 2.79 2.71 4.24a1.21 1.21 0 0 0 2.24-.12C10.06 9.66 11.5 7 12.88 4.27c.12-.25.09-.4-.18-.52z"
        fill={props.dark ? "#fff" : "#135d80"}
      />
    )}
  </Svg>
);

export const Delete = ({ width = 40, height = 40, color = "#fff" }) => (
  <Svg viewBox="0 0 40 40" width={width} height={height}>
    <path
      fill={color}
      d="M21.8,20.3l6.3-6.3c0.5-0.5,0.5-1.2,0-1.7c-0.5-0.5-1.2-0.5-1.7,0l-6.3,6.3l-6.3-6.3c-0.5-0.5-1.2-0.5-1.7,0
	c-0.5,0.5-0.5,1.2,0,1.7l6.3,6.3l-6.3,6.3c-0.5,0.5-0.5,1.2,0,1.7c0.2,0.2,0.5,0.3,0.8,0.3s0.6-0.1,0.8-0.3l6.3-6.3l6.3,6.3
	c0.2,0.2,0.5,0.3,0.8,0.3c0.3,0,0.6-0.1,0.8-0.3c0.5-0.5,0.5-1.2,0-1.7L21.8,20.3z"
    />
  </Svg>
);

export const Plus = ({ width = 40, height = 40, color = "#fff" }) => (
  <Svg viewBox="0 0 11 11" width={width} height={height}>
    <path
      fill={color}
      d="M4.423 10.583V0H6.16v10.583zM0 4.503h10.583V6.24H0z"
    />
  </Svg>
);
export const Minus = ({ width = 40, height = 40, color = "#fff" }) => (
  <Svg viewBox="0 0 11 11" width={width} height={height}>
    <path fill={color} d="M0 4.503h10.583V6.24H0z" />
  </Svg>
);
export const Dropdown = ({ width = 40, height = 63, color = "#fff" }) => (
  <Svg viewBox="0 0 40 63" width={width} height={height}>
    <polygon fill={color} points="20.8,3.6 8.5,28.2 33.1,28.2 	" />
    <polygon fill={color} points="20.8,60.7 33.1,36.2 8.5,36.2 	" />
  </Svg>
);

export const Edit = ({ width = 40, height = 40, color = "#fff" }) => (
  <Svg viewBox="0 0 40 40" width={width} height={height}>
    <path
      fill={color}
      d="M29.6,13.7L29.6,13.7c-0.3-1.4-1.5-2.6-2.9-2.9c-0.7-0.1-1.4,0-1.8,0.5l-9.6,9.6c-0.1,0.1-0.2,0.3-0.3,0.4
		l-1,4.1c-0.1,0.3,0,0.6,0.2,0.8c0.2,0.2,0.4,0.3,0.6,0.3c0.1,0,0.1,0,0.2,0l4-1.1c0.1,0,0.3-0.1,0.4-0.2l9.6-9.6
		C29.6,15.1,29.8,14.4,29.6,13.7z M28.3,14.7l-0.7,0.7c-0.5-1.1-1.5-2.1-2.6-2.6l0.7-0.7l0,0c0.2-0.2,0.5-0.2,0.8-0.2
		c0.9,0.2,1.8,1.1,2,2C28.6,14.3,28.5,14.6,28.3,14.7z M26.8,16.3l-7.5,7.5c-0.5-1.1-1.5-2.1-2.6-2.6l7.5-7.5
		C25.3,14,26.4,15.1,26.8,16.3z M18.3,24.4l-3.1,0.8l0.8-3.1C17,22.6,17.9,23.4,18.3,24.4z"
    />
    <path
      d="M19.3,20.7"
      style={{ fill: "none", stroke: color, strokeWidth: 1.2415 }}
    />
    <path
      fill={color}
      d="M24.8,30.8H14.4c-2.3,0-4.1-1.9-4.1-4.1V16.3c0-2.3,1.9-4.1,4.1-4.1h6.1c0.3,0,0.6,0.3,0.6,0.6
			c0,0.3-0.3,0.6-0.6,0.6h-6.1c-1.6,0-2.9,1.3-2.9,2.9v10.3c0,1.6,1.3,2.9,2.9,2.9h10.3c1.6,0,2.9-1.3,2.9-2.9v-7.1
			c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6v7.1C28.9,28.9,27.1,30.8,24.8,30.8z"
    />
  </Svg>
);

export const Expand = ({ width = 40, height = 40, color = "#fff" }) => (
  <Svg viewBox="0 0 40 40" width={width} height={height}>
    <path
      fill={color}
      d="M18.3,30.4C18,30.2,17.7,30,17.4,30l-5.1,0l5-5c0.2-0.2,0.4-0.5,0.4-0.9c0-0.3-0.1-0.6-0.4-0.9
		c-0.5-0.5-1.2-0.5-1.7,0l-5,5l0-5.1c0-0.3-0.1-0.6-0.3-0.9C10.1,22.2,9.8,22,9.4,22c0,0,0,0,0,0c-0.3,0-0.6,0.1-0.8,0.3
		c-0.2,0.2-0.4,0.5-0.4,0.9l0,7.9l0,0.1l0,0l0,0l0.1,0.2l0.4,0.7L9,31.8l-0.3,0.4l0.1,0.1l0.5,0.1l8,0c0.3,0,0.6-0.1,0.9-0.4
		c0.2-0.2,0.4-0.5,0.3-0.8C18.6,30.9,18.5,30.6,18.3,30.4z"
    />
    <path
      fill={color}
      d="M32,9.9l0-0.3l-0.1-0.3L31.6,9l0,0l-0.4-0.3l-0.4-0.1l0,0l-8,0c-0.3,0-0.6,0.1-0.9,0.4
		c-0.2,0.2-0.4,0.5-0.3,0.9c0,0.3,0.1,0.6,0.4,0.9c0.2,0.2,0.5,0.3,0.8,0.3c0,0,0,0,0,0l5.1,0l-5,5c-0.2,0.2-0.4,0.5-0.4,0.9
		s0.1,0.6,0.4,0.9c0.5,0.5,1.2,0.5,1.7,0l5-5v5.1c0,0.7,0.5,1.2,1.2,1.2c0,0,0,0,0,0c0.3,0,0.6-0.1,0.8-0.4c0.2-0.2,0.4-0.5,0.4-0.9
		L32,9.9z"
    />
  </Svg>
);
export const Collapse = ({ width = 40, height = 40, color = "#fff" }) => (
  <Svg viewBox="0 0 40 40" width={width} height={height}>
    <path
      transform="translate(15,-15)"
      fill={color}
      d="M18.3,30.4C18,30.2,17.7,30,17.4,30l-5.1,0l5-5c0.2-0.2,0.4-0.5,0.4-0.9c0-0.3-0.1-0.6-0.4-0.9
		c-0.5-0.5-1.2-0.5-1.7,0l-5,5l0-5.1c0-0.3-0.1-0.6-0.3-0.9C10.1,22.2,9.8,22,9.4,22c0,0,0,0,0,0c-0.3,0-0.6,0.1-0.8,0.3
		c-0.2,0.2-0.4,0.5-0.4,0.9l0,7.9l0,0.1l0,0l0,0l0.1,0.2l0.4,0.7L9,31.8l-0.3,0.4l0.1,0.1l0.5,0.1l8,0c0.3,0,0.6-0.1,0.9-0.4
		c0.2-0.2,0.4-0.5,0.3-0.8C18.6,30.9,18.5,30.6,18.3,30.4z"
    />
    <path
      transform="translate(-15,15)"
      fill={color}
      d="M32,9.9l0-0.3l-0.1-0.3L31.6,9l0,0l-0.4-0.3l-0.4-0.1l0,0l-8,0c-0.3,0-0.6,0.1-0.9,0.4
		c-0.2,0.2-0.4,0.5-0.3,0.9c0,0.3,0.1,0.6,0.4,0.9c0.2,0.2,0.5,0.3,0.8,0.3c0,0,0,0,0,0l5.1,0l-5,5c-0.2,0.2-0.4,0.5-0.4,0.9
		s0.1,0.6,0.4,0.9c0.5,0.5,1.2,0.5,1.7,0l5-5v5.1c0,0.7,0.5,1.2,1.2,1.2c0,0,0,0,0,0c0.3,0,0.6-0.1,0.8-0.4c0.2-0.2,0.4-0.5,0.4-0.9
		L32,9.9z"
    />
  </Svg>
);

export const ToggleMore = ({ width = 48, height = 31, color = "#fff" }) => (
  <Svg viewBox="0 0 48 31" width={width} height={height}>
    <path
      fill={color}
      d="M23.97 31.01c-1.2 0-2.3-.5-3-1.4l-20-23c-1.4-1.7-1.3-4.2.4-5.6 1.7-1.4 4.2-1.3 5.6.4l17 19.6 17-19.6c1.4-1.7 4-1.9 5.6-.4 1.7 1.4 1.9 4 .4 5.6l-20 23c-.7.9-1.8 1.4-3 1.4z"
    />
  </Svg>
);

export const WatchlistEye = ({ width = 40, height = 40, color = "#fff" }) => (
  <Svg viewBox="0 0 40 40" width={width} height={height}>
    <path
      fill={color}
      d="M35.7,19.6c-0.3-0.4-6.2-9.7-15.8-9.7c-9.6,0-15.6,9.3-15.8,9.7c-0.4,0.6-0.4,1.5,0,2.1
		c0.3,0.4,6.2,9.7,15.8,9.7c9.6,0,15.6-9.3,15.8-9.7C36.1,21.1,36.1,20.2,35.7,19.6z M19.9,29c-4.2,0-7.6-3.7-7.6-8.2
		c0-4.5,3.4-8.2,7.6-8.2c4.2,0,7.6,3.7,7.6,8.2C27.5,25.3,24.1,29,19.9,29z M5.4,20.6c0-0.1,3.4-5.3,9-7.8c-2.2,1.8-3.7,4.7-3.7,7.9
		c0,2.9,1.1,5.5,2.9,7.3C8.6,25.5,5.5,20.7,5.4,20.6z M34.4,20.7c0,0.1-3.2,4.9-8.3,7.4c1.8-1.8,2.9-4.4,2.9-7.3
		c0-3.2-1.4-6.1-3.7-7.9C31,15.2,34.4,20.5,34.4,20.7l0.7-0.6L34.4,20.7z"
    />
    <path
      fill={color}
      d="M19.9,16.7c-2.1,0-3.7,1.9-3.7,4.1c0,2.2,1.7,4.1,3.7,4.1c2,0,3.8-1.8,3.8-4.1C23.7,18.6,21.9,16.7,19.9,16.7z
		"
    />
  </Svg>
);

export const Like = ({ width = 28, height = 28, color = "#fff", ...props }) => (
  <svg width={width} height={height} viewBox="0 0 19 20" {...props}>
    <path
      d="M5 8c.9-.8 1.7-1.6 2.4-2.5.8-1 1.5-2 2-3.2.3-.6.5-1.1.9-1.5.4-.5 1-.8 1.7-.8.3 0 .6 0 .8.1h.1c.5.2.9.5 1.1 1 .2.4.3.9.3 1.4 0 .5-.1 1-.3 1.5l-.6 1.5c-.2.4-.3.8-.5 1.1h3c1.9 0 2.9 2 2 3.5 1.3.8 1.4 2.9.1 3.9.6 1.1.2 2.7-1 3.2.1.2.1.4.1.6 0 .7-.3 1.4-.9 1.8h-.1c-.3.2-.7.3-1.2.3h-4.7c-1 0-1.9-.2-2.9-.6-.7-.2-1.4-.6-2-.9-.3.3-.6.4-1 .4H1.6c-.4 0-.8-.2-1.1-.5-.3-.3-.5-.7-.5-1.1v-8c0-.8.7-1.5 1.5-1.5h2.7c.4.2.6.2.8.3zm1 9.1c.7.3 1.4.6 2 .9.8.3 1.6.5 2.4.5h4.7c.4 0 .8-.5.5-.9-.1-.2-.2-.3-.2-.5s0-.4.1-.5c.1-.2.2-.3.3-.4.1-.1.3-.2.5-.2.6-.1.7-.8.4-1.2-.1-.1-.2-.3-.3-.4 0-.2-.1-.3 0-.5 0-.2.1-.3.2-.5.1-.1.2-.2.4-.3h.1c.2-.1.3-.3.4-.5v-.3c0-.1 0-.2-.1-.3-.1-.2-.2-.3-.4-.4-.2 0-.3-.1-.4-.2l-.1-.1c-.4-.4-.4-1.1 0-1.5.1-.2.2-.4.2-.6 0-.1 0-.3-.1-.4 0-.1-.1-.2-.2-.3-.1-.1-.3-.2-.6-.2h-3.3c-1 0-1.7-1.1-1.2-2 .2-.4.4-.8.6-1.3.2-.5.4-.9.5-1.3.1-.3.2-.7.2-1 0-.3-.1-.5-.1-.7l-.3-.3h-.3c-.3 0-.4.1-.6.3-.2.2-.4.7-.6 1.1-.6 1.3-1.3 2.5-2.2 3.6-.8 1-1.6 1.8-2.6 2.7v7.7zM4.5 9.4zm-2.8 0v8h2.7v-8H1.7zm0 8z"
      strokeWidth={0}
      fill={color}
    />
  </svg>
);

export const Dislike = ({
  width = 28,
  height = 28,
  color = "#fff",
  ...props
}) => (
  <svg width={width} height={height} viewBox="0 0 19 20" {...props}>
    <path
      d="M4.8 12.1c-.2.1-.3.1-.5.1H1.5c-.8 0-1.5-.7-1.5-1.5v-8c0-.4.2-.8.5-1.1.3-.3.7-.5 1.1-.5h2.7c.4 0 .8.2 1 .4.7-.3 1.3-.6 2-.9 1-.3 1.9-.6 2.9-.6h4.7c.5 0 .9.1 1.2.3h.1c.6.4.9 1.1.9 1.8 0 .2 0 .4-.1.6 1.2.5 1.6 2.1 1 3.2 1.2 1 1.2 3-.1 3.9.9 1.6-.2 3.5-2 3.5h-3c.2.3.3.7.5 1.1l.6 1.5c.2.5.3 1 .3 1.5s-.1 1-.3 1.4c-.2.4-.6.8-1.1 1l-.4.1c-.2.1-.5.1-.8.1-.8 0-1.3-.3-1.7-.8-.4-.4-.6-.9-.9-1.5-.5-1.2-1.2-2.2-2-3.2-.7-.8-1.5-1.6-2.3-2.4zm1-9.2v8c.9.9 1.8 1.7 2.6 2.7.9 1.1 1.6 2.2 2.2 3.6.2.5.4.9.6 1.1.1.2.3.3.6.3h.3c.1 0 .2-.1.3-.3.1-.2.1-.4.1-.7 0-.3-.1-.6-.2-1s-.3-.9-.5-1.3c-.2-.5-.4-.9-.6-1.3-.4-.9.2-2 1.2-2h3.3c.3 0 .5-.1.6-.2.1-.1.1-.2.2-.3 0-.1.1-.2.1-.4s-.1-.5-.2-.6c-.4-.4-.4-1.1 0-1.5l.1-.1c.1-.1.3-.2.4-.2.2-.1.3-.2.4-.4 0-.1.1-.2.1-.3v-.3c-.1-.2-.2-.4-.4-.5h-.1c-.1-.1-.3-.2-.4-.3-.1-.1-.2-.3-.2-.5v-.5c.1-.2.2-.3.3-.4.4-.4.2-1.2-.4-1.2-.2 0-.4-.1-.5-.2-.1-.1-.3-.3-.3-.4-.1-.2-.1-.4-.1-.5 0-.2.1-.4.2-.5.2-.4-.1-.9-.5-.9h-4.7c-.8 0-1.6.2-2.4.5-.8 0-1.5.3-2.1.6zm-1.6 7.7zm-2.7 0h2.7v-8H1.5zm0-8z"
      strokeWidth={0}
      fill={color}
    />
  </svg>
);

export const Comment = ({
  width = 28,
  height = 28,
  color = "#fff",
  ...props
}) => (
  <svg width={width} height={height} viewBox="0 0 22 18" {...props}>
    <path
      d="M18.2 2.5C16.3 1 13.6 0 10.7 0 7.8 0 5.1 1 3.2 2.5 1.2 4.1 0 6.2 0 8.7c0 1 .2 2 .6 2.9.4.8.8 1.6 1.5 2.2l-.6 2.5c-.1.3 0 .5 0 .7.1.2.3.5.5.6.2.2.5.2.8.3.3 0 .5 0 .8-.2l2.6-1.3c.6.3 1.3.4 2 .6.8.2 1.7.3 2.6.3 2.9 0 5.6-1 7.5-2.5 2-1.6 3.2-3.7 3.2-6.2-.1-2.4-1.3-4.5-3.3-6.1zm-1.1 11.2c-1.6 1.3-3.9 2.1-6.5 2.1-.8 0-1.5-.1-2.2-.2-.7-.1-1.4-.4-2.1-.6-.2-.1-.5-.1-.7 0l-2.5 1.3.6-2.5c.1-.3 0-.5-.2-.7-.6-.6-1.1-1.3-1.4-2-.3-.7-.5-1.5-.5-2.3 0-1.9 1-3.7 2.6-5 1.6-1.3 3.9-2.1 6.5-2.1 2.5 0 4.8.8 6.5 2.1 1.6 1.3 2.6 3.1 2.6 5-.1 1.8-1.1 3.6-2.7 4.9z"
      strokeWidth={0}
      fill={color}
    />
  </svg>
);

export const Attach = ({
  width = 28,
  height = 28,
  color = "#fff",
  ...props
}) => (
  <svg width={width} height={height} viewBox="0 0 40 40" {...props}>
    <path
      d="M14.8 19.3l-5.5 5.5c-.7.7-1 1.6-1 2.5 0 .9.3 1.8 1 2.5s1.6 1 2.5 1c.9 0 1.8-.3 2.5-1l6.2-6.2 6.7-6.7c.3-.3.5-.7.5-1.1 0-.4-.2-.8-.5-1.1-.3-.3-.7-.5-1.1-.5-.4 0-.8.2-1.1.5l-9.6 9.6c-.4.4-1.1.4-1.6 0-.4-.4-.4-1.1 0-1.6l9.6-9.6c.7-.7 1.7-1.1 2.6-1.1 1 0 1.9.4 2.6 1.1.7.7 1.1 1.7 1.1 2.6s-.4 1.9-1.1 2.6L22 25.1l-6.2 6.2c-1.1 1.1-2.6 1.7-4 1.7s-2.9-.5-4-1.6l-.1-.1c-1.1-1.1-1.7-2.6-1.7-4 0-1.5.6-2.9 1.7-4l6.2-6.2 7.8-7.8C23.2 7.7 25.1 7 27.1 7c1.9 0 3.8.7 5.3 2.2 1.4 1.4 2.2 3.4 2.2 5.3s-.7 3.8-2.2 5.3L21.5 30.5c-.4.4-1.1.4-1.6 0-.4-.4-.4-1.1 0-1.6l10.8-10.8c1-1 1.5-2.4 1.5-3.7 0-1.3-.5-2.7-1.5-3.7S28.3 9.2 27 9.2c-1.3 0-2.7.5-3.7 1.5l-8.5 8.6z"
      fill={color}
    />
  </svg>
);

export const Send = ({ width = 28, height = 28, color = "#fff", ...props }) => (
  <svg width={width} height={height} viewBox="0 0 40 40" {...props}>
    <path
      d="M33.2 9.6v-.1h-.1l-24.4 14c-.3.2-.4.6-.2.9.1.2.3.3.5.3l8.3 1.9 1.5 4.4c.1.3.5.5.8.4.1-.1.3-.1.3-.3l2.4-3.3 6.3 1.4c.3.1.7-.1.8-.5l4.7-18.5-.9-.6zM16.6 25l-6.7-1.5 18.8-10.8L16.6 25zm2.1 4l-.8-2.4 2.2.5-1.4 1.9zm8.7-1.5l-9.3-2.1L31.3 12l-3.9 15.5z"
      fill={color}
    />
  </svg>
);

export const Logo = ({ fill = "#fff", scale = 1 }) => (
  <svg width={119.97 * scale} height={44.99 * scale} viewBox="0 0 119.97 44.99">
    <title>vox</title>
    <path
      d="M67.8 26.86L60.17 7.64A1.71 1.71 0 0 1 60 6.9 2 2 0 0 1 62 5a1.86 1.86 0 0 1 1.77 1.1l5.84 15.49L75.46 6.1A1.9 1.9 0 0 1 77.24 5a2 2 0 0 1 1.95 1.9 1.71 1.71 0 0 1-.13.74l-7.63 19.22a1.94 1.94 0 0 1-3.63 0zM79.62 16.54c0-8 3.86-11.79 10.65-11.79s10.65 3.83 10.65 11.79S97.06 28.3 90.27 28.3s-10.65-3.9-10.65-11.76zm4 0c0 5.54 2.18 8.26 6.62 8.26s6.62-2.72 6.62-8.26-2.18-8.3-6.62-8.3-6.59 2.76-6.59 8.3zM110.49 19.57l-5.17 7.66a1.9 1.9 0 0 1-1.61.87 2 2 0 0 1-1.95-1.95 1.78 1.78 0 0 1 .34-1.07l6.28-8.8L102.53 8a1.95 1.95 0 0 1 1.58-3 1.82 1.82 0 0 1 1.58.81l4.8 7.15 4.8-7.15a1.82 1.82 0 0 1 1.58-.81 1.95 1.95 0 0 1 1.58 3l-5.84 8.23 6.28 8.8a1.78 1.78 0 0 1 .34 1.07 2 2 0 0 1-1.95 1.95 1.9 1.9 0 0 1-1.61-.87z"
      fill={fill}
    />
    <g fill={fill}>
      <path d="M64.38 38.52l-2.84-5.43v6.71a.17.17 0 1 1-.34 0v-7.37a.17.17 0 0 1 .17-.17.15.15 0 0 1 .15.09l3 5.77 3-5.77a.15.15 0 0 1 .15-.09.17.17 0 0 1 .17.17v7.37a.17.17 0 1 1-.34 0v-6.71l-2.8 5.43a.17.17 0 0 1-.31 0zM72.76 37.49l-.93 2.36a.19.19 0 0 1-.18.12.18.18 0 0 1-.18-.18.26.26 0 0 1 0-.09l2.9-7.32a.17.17 0 0 1 .17-.12.18.18 0 0 1 .18.12l2.89 7.32a.27.27 0 0 1 0 .09.18.18 0 0 1-.19.18.19.19 0 0 1-.18-.13l-.92-2.35zm1.8-4.66l-1.69 4.34h3.38zM81.6 39.79a.18.18 0 1 1-.36 0v-7.26a.18.18 0 0 1 .18-.18h2.35a2 2 0 0 1 2 2 2 2 0 0 1-2 2.06h-.27l2.38 3.22a.2.2 0 0 1 0 .11.19.19 0 0 1-.35.09l-2.47-3.42H81.6zm0-3.66h2.2a1.74 1.74 0 0 0 0-3.47h-2.2zM93.83 32.33a.19.19 0 0 1 .34.12.19.19 0 0 1-.06.13l-2.6 2.92 3 4.17a.19.19 0 1 1-.31.2l-2.9-4.09-1.3 1.45v2.56a.18.18 0 1 1-.36 0v-7.35a.18.18 0 0 1 .36 0v4.28zM98.16 39.88a.18.18 0 0 1-.16-.18v-7.17a.18.18 0 0 1 .18-.18H102a.16.16 0 1 1 0 .31h-3.66v3.27h2.82a.16.16 0 0 1 0 .31h-2.82v3.32h3.75a.16.16 0 0 1 0 .31zM105.42 32.67a.16.16 0 1 1 0-.31h5a.16.16 0 1 1 0 .31h-2.32v7.13a.18.18 0 1 1-.36 0v-7.13zM116.12 32.5c-1.41 0-1.93.7-1.93 1.5 0 2.21 4.45 1.29 4.45 4 0 1.34-.93 2.08-2.61 2.08a2.85 2.85 0 0 1-2.55-1.35.18.18 0 0 1 0-.1.17.17 0 0 1 .17-.17.16.16 0 0 1 .15.09 2.55 2.55 0 0 0 2.2 1.17c1.45 0 2.25-.57 2.25-1.77 0-2.43-4.45-1.38-4.45-4 0-1 .69-1.8 2.29-1.8a2.74 2.74 0 0 1 2.34 1.11.18.18 0 0 1 0 .1.17.17 0 0 1-.17.17.15.15 0 0 1-.13-.07 2.35 2.35 0 0 0-2.01-.96z" />
    </g>
    <path
      fill="none"
      stroke={fill}
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={0.347}
      d="M59.99.17h59.8M59.99 44.81h59.8"
    />
    <g fill={fill}>
      <circle
        cx={6.94}
        cy={7.09}
        r={6.93}
        transform="rotate(-33.54 6.928 7.101)"
      />
      <circle
        cx={27.46}
        cy={38.05}
        r={6.93}
        transform="rotate(-33.54 27.465 38.05)"
      />
      <circle
        cx={47.98}
        cy={7.09}
        r={6.94}
        transform="rotate(-56.46 47.976 7.089)"
      />
      <circle
        cx={27.46}
        cy={38.05}
        r={6.94}
        transform="rotate(-56.46 27.454 38.05)"
      />
      <path
        d="M48 7.09l-6.89-.38s-.61 15.56-13.63 24.4c-13-8.83-13.63-24.4-13.63-24.4l-6.89.38-3 6.2a31.77 31.77 0 0 1 16.59 25l7-.27 7 .27A31.77 31.77 0 0 1 51 13.3z"
        opacity={0.5}
      />
    </g>
  </svg>
);

export const PencilBorder = props => (
  <svg width={50} height={50} viewBox="0 0 100 100" {...props}>
    <path
      fill="#FFFFFF"
      d="M49.7 94.6c-24.8 0-45-20.2-45-45s20.2-45 45-45 45 20.2 45 45-20.2 45-45 45zm0-86.5C26.8 8.1 8.2 26.7 8.2 49.6s18.6 41.5 41.5 41.5 41.5-18.6 41.5-41.5S72.6 8.1 49.7 8.1z"
    />
    <path
      fill="#FFFFFF"
      d="M74.8 33.6c.4 2.2-.1 4.2-1.5 5.6L41.8 70.7c-.3.3-.7.5-1.1.6l-13.2 3.5c-1.7.4-3.3-1.2-2.8-2.8l3.4-13.3c.1-.5.3-.9.7-1.2L60.1 26c1.4-1.4 3.4-1.9 5.6-1.5 4.3.8 8.3 4.8 9.1 9.1zM27.4 72l11.5-3c-1.4-3.8-4.8-7.2-8.6-8.6L27.4 72zm29.8-39.3L31.9 58.1c4.1 1.7 7.6 5.2 9.3 9.3L66.6 42c-1.3-4.2-5.1-8-9.4-9.3zm4.9-4.8l-2.7 2.7c4.1 1.7 7.6 5.2 9.3 9.3l2.7-2.7c.7-.7.9-1.9.7-3.2-.6-3.1-3.7-6.3-6.9-6.9-1.2-.2-2.4.1-3.1.8z"
    />
  </svg>
);

export const GearBorder = props => (
  <svg width={50} height={50} viewBox="0 0 100 100" {...props}>
    <path
      fill="#FFFFFF"
      d="M49.2 94.7c-24.8 0-45-20.2-45-45s20.2-45 45-45 45 20.2 45 45-20.2 45-45 45zm0-86.6C26.3 8.1 7.6 26.8 7.6 49.7s18.6 41.5 41.5 41.5 41.5-18.6 41.5-41.5S72.1 8.1 49.2 8.1z"
    />
    <path
      fill="#FFFFFF"
      d="M49.2 40.3c2.6 0 4.9 1 6.6 2.7 1.7 1.7 2.7 4 2.7 6.6 0 2.6-1 4.9-2.7 6.6-1.7 1.7-4 2.7-6.6 2.7-2.6 0-4.9-1-6.6-2.7-1.7-1.7-2.7-4-2.7-6.6 0-2.6 1-4.9 2.7-6.6 1.6-1.7 4-2.7 6.6-2.7zm5.6-11.5c.9.2 1.8.6 2.6.9.9.4 1.7.8 2.5 1.2l2.2-2.2c.8-.8 2-.8 2.8 0l5.1 5.1c.8.8.8 2 0 2.8l-2.2 2.2c.5.8.9 1.7 1.2 2.5.4.8.7 1.7.9 2.6H73c1.1 0 2 .9 2 2v7.2c0 1.1-.9 2-2 2h-3c-.2.9-.5 1.8-.9 2.7v.1l-1.2 2.4 2.2 2.2c.8.8.8 2.1 0 2.8L65 70.6c-.8.8-2 .8-2.8 0L60 68.4c-.8.5-1.6.9-2.5 1.2-.9.3-1.7.7-2.6.9v3.1c0 1.1-.9 2-2 2h-7.2c-1.1 0-2-.9-2-2v-3.1c-.9-.3-1.8-.6-2.6-.9-.9-.4-1.7-.8-2.5-1.2l-2.2 2.2c-.8.8-2 .8-2.8 0l-5.1-5.1c-.8-.8-.8-2 0-2.8l2.2-2.2c-.5-.8-.9-1.6-1.2-2.5-.4-.9-.7-1.8-.9-2.7h-3.1c-1.1 0-2-.9-2-2v-7.2c0-1.1.9-2 2-2h3.1l.9-2.7c.4-.8.8-1.7 1.2-2.5l-2.2-2.2c-.8-.8-.8-2 0-2.8l5.1-5.1c.8-.8 2-.8 2.8 0l2.2 2.2c.8-.5 1.7-.9 2.5-1.2.8-.3 1.7-.7 2.7-.9v-3.1c0-1.1.9-2 2-2H53c1.1 0 2 .9 2 2v3h-.2zm1.1 4.6c-1.1-.4-2.2-.8-3.3-1-1-.1-1.8-1-1.8-2v-2.7h-3.2v2.7c0 .9-.7 1.8-1.6 2-1.2.2-2.4.6-3.5 1-1.1.5-2.2 1-3.2 1.7-.8.5-1.8.5-2.5-.2l-2-1.9-2.3 2.3 1.9 1.9c.7.7.8 1.8.3 2.6-.7 1-1.3 2.1-1.7 3.2-.5 1.1-.8 2.2-1 3.3-.1 1-.9 1.8-2 1.8h-2.7v3.2H30c.9 0 1.8.7 2 1.6.2 1.2.6 2.4 1 3.5.5 1.1 1 2.2 1.7 3.2.5.8.4 1.8-.2 2.5l-1.9 2 2.3 2.3 1.9-1.9c.7-.7 1.8-.8 2.6-.3 1 .7 2.1 1.3 3.2 1.7 1.1.4 2.2.8 3.3 1 1 .1 1.8.9 1.8 2v2.7h3.2v-2.7c0-.9.7-1.8 1.6-2 1.2-.2 2.4-.6 3.5-1 1.1-.5 2.2-1 3.2-1.7.8-.5 1.8-.5 2.5.2l1.9 1.9 2.3-2.3-1.9-1.8c-.7-.7-.8-1.8-.3-2.6.7-1 1.2-2 1.7-3.1v-.1c.4-1.1.8-2.2 1-3.3.1-1 1-1.8 2-1.8h2.7v-3.2h-2.7c-.9 0-1.8-.7-2-1.6-.2-1.2-.6-2.4-1-3.5-.5-1.1-1-2.2-1.7-3.2-.5-.8-.5-1.8.2-2.5l2-2-2.3-2.3-1.9 1.9c-.7.7-1.7.8-2.6.3-1-.7-2.1-1.3-3.2-1.8zm-1.8 11.3c-1.3-1.3-3-2-4.9-2-1.9 0-3.7.8-4.9 2-1.2 1.3-2 3-2 4.9 0 1.9.8 3.7 2 4.9 1.3 1.3 3 2 4.9 2 1.9 0 3.7-.8 4.9-2 1.3-1.2 2-3 2-4.9 0-1.9-.7-3.6-2-4.9z"
    />
  </svg>
);

export const XBorder = props => (
  <svg width={50} height={50} viewBox="0 0 100 100" {...props}>
    <path
      fill="#FFFFFF"
      d="M49.7 94.6c-24.8 0-45-20.2-45-45s20.2-45 45-45 45 20.2 45 45-20.2 45-45 45zm0-86.5C26.8 8.1 8.2 26.7 8.2 49.6s18.6 41.5 41.5 41.5 41.5-18.6 41.5-41.5S72.6 8.1 49.7 8.1z"
    />
    <g transform="translate(15, 15)">
      <Delete width={70} height={70} />
    </g>
  </svg>
);

export const Head = props => (
  <svg width={21.2} height={21.2} viewBox="0 0 21.2 21.2" {...props}>
    <path
      d="M6.1 15.3c1.3-.4 1.8-.6 1.9-2.5-.1-.1-.2-.2-.2-.3-.1-.2-.2-.3-.2-.5a.6.6 0 0 0-.1-.4.37.37 0 0 0-.1-.3l-.1-.1A3 3 0 0 1 7 10c0-.7.1-.9.3-1a10.53 10.53 0 0 1-.1-1.2 3.09 3.09 0 0 1 1.1-2.6 3.75 3.75 0 0 1 4.5 0 3.07 3.07 0 0 1 1.1 2.1v.5c0 .5-.1 1.1-.1 1.2.1.1.3.3.3 1a3 3 0 0 1-.3 1.2v.1c0 .1-.1.2-.1.3a.76.76 0 0 1-.1.4.76.76 0 0 1-.2.5c-.1.1-.2.3-.3.4.1 1.9.6 2.1 1.9 2.5a9.38 9.38 0 0 1 1.5.6l.2.2a.66.66 0 0 1-.2.7.35.35 0 0 0-.2.1H4.8a.47.47 0 0 1-.5-.5c0-.8 1.4-1.1 1.8-1.2zm13.4.2v4.1h-4.1a.79.79 0 0 0-.8.8.86.86 0 0 0 .8.8h4.9a.86.86 0 0 0 .8-.8v-4.9a.86.86 0 0 0-.8-.8.79.79 0 0 0-.8.8zM5.7 19.6H1.6v-4.1a.86.86 0 0 0-.8-.8.79.79 0 0 0-.8.8v4.9a.86.86 0 0 0 .8.8h4.9a.8.8 0 1 0 0-1.6zM1.6 5.7V1.6h4.1a.79.79 0 0 0 .8-.8.86.86 0 0 0-.8-.8H.8a.79.79 0 0 0-.8.8v4.9a.79.79 0 0 0 .8.8.86.86 0 0 0 .8-.8zm13.9-4.1h4.1v4.1a.79.79 0 0 0 .8.8.86.86 0 0 0 .8-.8V.8a.86.86 0 0 0-.8-.8h-4.9a.79.79 0 0 0-.8.8c-.1.5.3.8.8.8zM9 12.8c-.1 2.1-.5 2.6-1.6 3.1h6.4c-1.1-.4-1.5-1-1.6-3.1v-.3c0-.1.1-.2.2-.3.1-.1.1-.2.2-.3s.1-.1.1-.2.1-.3.1-.4c0-.1.1-.3.1-.4s.1-.2.1-.3a1.45 1.45 0 0 0 .2-.7v-.3a4.19 4.19 0 0 1-.2-1.8v-.4a2.1 2.1 0 0 0-.7-1.4A2.86 2.86 0 0 0 9 6a2.09 2.09 0 0 0-.7 1.8 7.08 7.08 0 0 1-.1 1.5.37.37 0 0 1-.1.3v.3a1.17 1.17 0 0 0 .2.7c0 .1.1.2.1.3 0 .1.1.2.1.3 0 .1.1.3.1.4a.1.1 0 0 0 .1.1c.1.1.1.2.2.2.1.1.1.2.2.3a1.76 1.76 0 0 0-.1.6z"
      fill="#fff"
    />
  </svg>
);

export const Picture = props => (
  <svg width={22.2} height={22.1} viewBox="0 0 22.2 22.1" {...props}>
    <path
      d="M8.3 10.5a.49.49 0 0 0-.7.1l-4.1 6.3a.37.37 0 0 0-.1.3.47.47 0 0 0 .5.5h14.5a.37.37 0 0 0 .3-.1.66.66 0 0 0 .2-.7l-5.7-8.7c0-.1-.1-.1-.2-.2a.48.48 0 0 0-.7.1l-2.7 4.2-1.1-1.8c-.1.1-.2.1-.2 0zm1.7 3.2l2.7-4.2 4.7 7.3H4.8L8 11.9l1.2 1.8a.47.47 0 0 0 .8 0zM4.7 6.3a2.1 2.1 0 1 0 2.1-2.1 2.18 2.18 0 0 0-2.1 2.1zm3.1 0a1 1 0 1 1-1-1 1.08 1.08 0 0 1 1 1zm13.5 9a.79.79 0 0 0-.8.8v4.2h-4.2a.8.8 0 1 0 0 1.6h5.1a.79.79 0 0 0 .8-.8V16a.89.89 0 0 0-.9-.7zM6 20.4H1.8v-4.2a.79.79 0 0 0-.8-.8.79.79 0 0 0-.8.8v5.1a.79.79 0 0 0 .8.8h5.1a.79.79 0 0 0 .8-.8.9.9 0 0 0-.9-.9zM.9 6.8a.79.79 0 0 0 .8-.8V1.8h4.2a.79.79 0 0 0 .8-.8.79.79 0 0 0-.8-.8H.8A.79.79 0 0 0 0 1v5.1a1.11 1.11 0 0 0 .9.7zM21.3 0h-5.1a.79.79 0 0 0-.8.8.79.79 0 0 0 .8.8h4.2v4.2a.8.8 0 1 0 1.6 0V.7c.2-.3-.2-.7-.7-.7z"
      fill="#fff"
    />
  </svg>
);

// \/
export const ArrowDown = props => (
  <Svg width={20} height={12.96} viewBox="0 0 20 12.96" {...props}>
    <path
      d="M10 13a1.67 1.67 0 0 1-1.26-.58L.41 2.76A1.65 1.65 0 0 1 .58.41a1.66 1.66 0 0 1 2.35.17L10 8.74 17.07.58a1.67 1.67 0 0 1 2.52 2.18l-8.33 9.62A1.67 1.67 0 0 1 10 13z"
      fill="#6b8096"
    />
  </Svg>
);
// /\
export const ArrowUp = props => (
  <Svg width={20} height={12.96} viewBox="0 0 20 12.96" {...props}>
    <title>arrow up</title>
    <path
      d="M10 0a1.67 1.67 0 0 1 1.26.58l8.33 9.62a1.67 1.67 0 0 1-2.52 2.18L10 4.22l-7.07 8.16a1.66 1.66 0 0 1-2.35.17 1.65 1.65 0 0 1-.17-2.35L8.74.58A1.67 1.67 0 0 1 10 0z"
      fill="#6b8096"
    />
  </Svg>
);

export const Tick = props => (
  <Svg width={14} height={14} viewBox="0 0 100 100" {...props}>
    <path
      d="M85.2 5.6c-2.5-1.1-3.7-.9-5.1 1.7l-37.6 72-23.7-37.2c-1.7-2.3-2.8-2.5-5.1-1.1l-5 3c-2.5 1.7-2.8 2.8-1.1 5.1 8.2 13.3 16.7 26.6 25.1 39.5 5.9 9 15.8 8.2 20.6-1.1 13-24.6 26.3-49.4 39-74.3 1.1-2.3.8-3.7-1.7-4.8l-5.4-2.8z"
      fill="#fff"
    />
  </Svg>
);

export const PlusThin = props => (
  <svg width={14} height={14} viewBox="0 0 100 100" {...props}>
    <path
      d="M95 53.1v-5.5c0-2.6-.9-3.5-3.5-3.5H56.2V8.8c0-2.6-.9-3.5-3.5-3.5h-5.5c-2.6 0-3.5.9-3.3 3.3L43.7 44H8.4c-2.6 0-3.5.9-3.3 3.3L5 53.1c0 2.6.9 3.5 3.5 3.5l35.4-.2-.2 35.4c0 2.6.9 3.5 3.5 3.5l5.7-.2c2.4.2 3.3-.7 3.3-3.3V56.5l35.4-.2c2.5.3 3.4-.6 3.4-3.2z"
      fill="#fff"
    />
  </svg>
);

export const Document = props => (
  <Svg inline width={20} height={20} viewBox="0 0 80 80" {...props}>
    <path
      d="M56.2 56.2H24.9c-.9 0-1.6.7-1.6 1.6 0 .9.7 1.6 1.6 1.6h31.3c.9 0 1.6-.7 1.6-1.6 0-.8-.7-1.6-1.6-1.6zM23.3 35.1c0 .9.7 1.6 1.6 1.6h31.3c.9 0 1.6-.7 1.6-1.6 0-.9-.7-1.6-1.6-1.6H24.9c-.9 0-1.6.7-1.6 1.6zm47.1-8.9L50.9 6.7c-.5-.5-1.2-.8-1.9-.8H17.1c-2 0-3.8.8-5.1 2.1-1.3 1.3-2.1 3.1-2.1 5.1v55.6c0 2 .8 3.8 2.1 5.1 1.3 1.3 3.1 2.1 5.1 2.1H64c1.9 0 3.7-.8 5-2l.1-.1c1.3-1.3 2.1-3.1 2.1-5.1V28.1c0-.7-.3-1.4-.8-1.9zM50.6 14L63 26.4h-9.5c-.8 0-1.5-.3-2-.9l-.1-.1c-.5-.5-.8-1.2-.8-2V14zm15.2 54.7c0 .5-.2.9-.5 1.3-.3.3-.8.5-1.3.5H17.1c-.5 0-1-.2-1.3-.5-.3-.3-.5-.8-.5-1.3V13.1c0-.5.2-.9.5-1.3.3-.3.8-.5 1.3-.5h30.3v12.3c0 1.6.7 3.1 1.7 4.2l.1.1c1.1 1.1 2.6 1.8 4.3 1.8h12.3v39zm-9.6-23.8H24.9c-.9 0-1.6.7-1.6 1.6 0 .9.7 1.6 1.6 1.6h31.3c.9 0 1.6-.7 1.6-1.6 0-.9-.7-1.6-1.6-1.6z"
      fill="#135d80"
    />
  </Svg>
);

export const DocumentImg =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAmCAMAAACS/WnbAAAAdVBMVEUAAAAjp9wjptwjp94kqd8TYINVvObg8voSXoASW34JMEIjpdo5seIRV3grrOATX4IQTmwekMAORmELOU8JMEIPTmtTvOYej74bhK8LOU/p9vsTXX8RU3ITYIMzr+EVaY4XcZcfk8MciLQLN0wkqd8TXYD///+/R4XtAAAAJHRSTlMA6eXs9NvB4+P8D9vM8d3d0cOwZAzPwsG7Yenl4tPQzMbEu1S1KvPnAAAArElEQVQ4y9XT2Q6CMBCF4QEELVXZRMR96fH9H1HaYFq1rQnGRP+rXnxpMpkMEbU5w1PbBelKWJppUQF+kQMxD8yiTIm0Bwzg4rEYpuie4SuQn7DUA04rJdygEFIg9QBxVsIFjk1T7JRwAN0gcJj0bTSwF/0fmF6Nlh+DxALEyOg7U+zHfev5uzGHgjC5F/3cNuXxekEOZDywxmMJKni7EJXwVFJXWzNYY3VFdAPZL47toy39WgAAAABJRU5ErkJggg==";
